import { ChangeDetectionStrategy, Component, inject, Input, signal, WritableSignal } from '@angular/core';
import { LnImageFrameComponent } from '@components/ln-image-frame/ln-image-frame.component';
import { TrashSvgIconComponent } from '@components/svg-icons/trash-svg-icon/trash-svg-icon.component';
import { ProductItemCardQuantitySelectorComponent } from '@components/product-item-card-quantity-selector/product-item-card-quantity-selector.component';
import { ShoppingCartItemsInterface } from '@interfaces/shopping-cart/shopping-cart-items-interface';
import { ShoppingCartState } from '../../../states/shopping-cart-state';
import { DecimalPipe, NgClass } from '@angular/common';
import { MenuActions } from '../../../states/menu_actions';
import { TranslocoPipe } from '@jsverse/transloco';

@Component({
  selector: 'ln-product-item-card',
  imports: [
    LnImageFrameComponent,
    TrashSvgIconComponent,
    ProductItemCardQuantitySelectorComponent,
    NgClass,
    TranslocoPipe,
    DecimalPipe,
  ],
  templateUrl: './product-item-card.component.html',
  styleUrl: './product-item-card.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProductItemCardComponent {
  @Input({ required: true }) product!: ShoppingCartItemsInterface;
  private shoppingCartState = inject(ShoppingCartState);
  private menuActions = inject(MenuActions);
  protected showButonSpinner: WritableSignal<boolean> = signal(false);
  deleteItem() {
    this.showButonSpinner.set(true);
    this.shoppingCartState.deleteItem(this.product.id).subscribe(() => {
      this.showButonSpinner.set(false);
    });
  }
  get singlePiece(): boolean {
    return this.product.producto.productoPrincipal.isPiezaUnica;
  }

  navigateToProductDetails() {
    this.menuActions.navigateToProductDetails(
      this.product.producto.productoPrincipal.vendedorId,
      this.product.producto.productoPrincipal.id,
      this.product.producto.id
    );
  }
}
